/* global apigClientFactory */

/* @ngInject */
export default class {
  constructor(JwtClass, $q, $log, Swal) {
    this.$log = $log;
    this.$q = $q;
    this.Swal = Swal;
    const apiClient = apigClientFactory.newClient();

    Object.keys(apiClient).forEach(key => {
      this[key] = (params = {}, body = {}, additionalParams = {}, noSwal = false) => {
        return JwtClass.status(key)
          .then(token => {
            if (token) params.Authorization = token;
            if (!additionalParams.headers) additionalParams.headers = {};
            additionalParams.headers.Authorization = token;
            return apiClient[key](params, body, additionalParams).catch(payload => {
              return payload;
            });
          })
          .then(payload => {
            if (!payload) throw new Error('Bad Request');
            if (!noSwal && payload.status === 401) {
              this.Swal.alert('Error', 'User is not authorized', 'warning');
              throw new Error('exit');
            }
            if (!noSwal && payload.status === 0) {
              this.Swal.alert('Error', 'There was a critical error', 'warning');
              throw new Error('exit');
            }
            if (payload.status >= 401 || payload.status === 0) {
              this.$log.error(`ERROR: ${payload.status}`, payload);
              throw payload;
            }
            return payload;
          });
      };
    });
  }

  scan(func, params, body, additionalParams) {
    return this.$q((resolve, reject) => {
      const obj = {
        items: []
      };

      const scanLambda = LastEvaluatedKey => {
        if (LastEvaluatedKey) {
          if (!additionalParams.queryParams) additionalParams.queryParams = {};
          for (let key in LastEvaluatedKey) {
            additionalParams.queryParams[`scan:LastEvaluatedKey:${key}`] = LastEvaluatedKey[key];
          }
        }
        func(params, body, additionalParams)
          .then(({ data: { items, headers: { scan } } }) => {
            if (items) obj.items.push(...items);
            if (scan && scan.LastEvaluatedKey) return scanLambda(scan.LastEvaluatedKey);
            resolve(obj);
          })
          .catch(error => {
            this.$log.error(error);
            reject(error);
          });
      };

      scanLambda();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ApiClass.js